export const AUTH_Success = "success"
export const AUTH_login_Success = "login/success"
export const AUTH_GOOGLE_SUCCESS="google/singup"
export const AUTH_Failed = "failed"
export const AUTH_Loading = "loading"
export const AUTH_Logout = "logout"